import React from "react";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  box: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },

  div: {
    width: "100px",
    height: "100px",
    background: "black",
  },
}));

const SignUp = () => {
  const classes = useStyles();

  return (
    <div className={classes.box}>
      <form className={classes.div}></form>
    </div>
  );
};

export default SignUp;
